import { createSignal, JSX, mergeProps, Show } from 'solid-js';
import { Button, Icon } from '@photonhealth/components';

type PhotonFormWrapperProps = {
  closeTitle?: string;
  closeBody?: string;
  footer?: JSX.Element;
  title: string;
  titleIconName?: string;
  form?: JSX.Element;
  onClosed: () => void;
  checkShouldWarn?: () => boolean;
};

export const PhotonFormWrapper = (p: PhotonFormWrapperProps) => {
  const props = mergeProps(
    {
      closeTitle: 'Lose unsaved changes?',
      closeBody: 'You will not be able to recover unsaved changes.',
      checkShouldWarn: () => false
    },
    p
  );
  let ref: any;
  const [closeDialogOpen, onCloseDialogOpen] = createSignal<boolean>(false);

  const handleConfirm = () => {
    onCloseDialogOpen(false);
    props.onClosed();
  };
  const handleCancel = () => onCloseDialogOpen(false);

  return (
    <div ref={ref} class="z-50 fixed inset-0 flex flex-col bg-[#F9FAFB]">
      {/* Close Wrapper Modal */}
      <photon-dialog
        label={props.closeTitle}
        open={closeDialogOpen()}
        confirm-text="Yes, Close"
        cancel-text="Keep Editing"
        on:photon-dialog-confirmed={handleConfirm}
        on:photon-dialog-canceled={handleCancel}
        on:photon-dialog-alt={handleCancel}
      >
        <p class="font-sans text-lg xs:text-base">{props.closeBody}</p>
      </photon-dialog>

      <header class="flex-shrink-0 flex items-center px-4 py-2 md:px-8 md:py-3 bg-white shadow-card">
        <div class="flex items-center">
          <Button
            variant="naked"
            size="sm"
            onClick={() => {
              if (props.checkShouldWarn()) {
                onCloseDialogOpen(true);
              } else {
                props.onClosed();
              }
            }}
          >
            <div class="text-black text-xl md:text-3xl">
              <Icon name="xMark" />
            </div>
          </Button>
        </div>
        <div class="flex-1 flex justify-center items-center min-w-0 px-2">
          <Show when={props.titleIconName}>
            <sl-icon name={props.titleIconName} class="flex-shrink-0" />
          </Show>
          <p class="ml-1 font-sans text-lg md:text-xl font-medium truncate">{props.title}</p>
        </div>
        <div class="flex items-center w-[44px]" />
      </header>
      <main
        class="flex-1 overflow-y-auto overscroll-contain"
        style={{ '-webkit-overflow-scrolling': 'touch' }}
      >
        <div class="px-4 pt-4 pb-4 md:px-4 w-full sm:w-[600px] xs:mx-auto">{props.form}</div>
      </main>
      <Show when={props.footer}>
        <footer class="flex-shrink-0 bg-white shadow-card px-4 py-4 md:px-8">
          <div class="flex flex-col xs:flex-row-reverse xs:justify-start gap-2 items-center w-full sm:w-[600px] xs:mx-auto sm:px-4">
            {props.footer}
          </div>
        </footer>
      </Show>
    </div>
  );
};
